module.exports = __webpack_public_path__ + "static/img/erp2.30e6ddda.png";